<!-- v1.5 -->

<template>
  <div id="allpaabaCollectionGrid">
    <div class="container-fluid">
      <div class="product-grid" id="anchor-product-grid">
        <div class="row">
          <!-- ========== MINIMIZED GRID 1  ========== -->
          <div
            v-for="(product, index) in gridProducts.slice(0, 5)"
            class="col-sm-6 col-lg-4"
          >
            <ProductCard :product="product" />
          </div>
          <!-- .col -->
          <div class="col-sm-6 col-lg-4 mobile-hidden">
            <div
              class="ctpx-non-product-item"
              style="
                background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/files/allpaaba-testimonial-bg-f23.jpg?v=1695935427);
              "
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0281/7544/t/80/assets/five-star.png?v=131352830295322815931603484504"
                class="img-responsive"
                alt="five stars"
              />
              <h2 class="display-3">Perfect Travel Bag!</h2>
              <blockquote>
                <p>
                  “I have both the 28L and the 35L! I took a 2 week trip
                  backpacking across Europe and it [Allpa 35L] had ample space
                  for everything I needed.”
                </p>
                <cite>Hunter M.</cite>
                <span>Verified Buyer</span>
              </blockquote>
            </div>
            <!-- .ctpx-non-product-item -->
          </div>
          <!-- .col-sm-6 -->
          <!-- ========== MAXIMIZED GRID 1  ========== -->
          <div
            v-for="(product, index) in gridProducts.slice(5)"
            class="col-sm-6 col-lg-4"
          >
            <ProductCard :product="product" />
          </div>
          <!-- .col -->
          <div class="col-sm-6 col-lg-4 mobile-only">
            <div
              class="ctpx-non-product-item"
              style="
                background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/files/allpaaba-testimonial-bg-f23.jpg?v=1695935427);
              "
            >
              <img
                src="https://cdn.shopify.com/s/files/1/0281/7544/t/80/assets/five-star.png?v=131352830295322815931603484504"
                class="img-responsive"
                alt="five stars"
              />
              <h2 class="display-3">Perfect Travel Bag!</h2>
              <blockquote>
                <p>
                  “I have both the 28L and the 35L! I took a 2 week trip
                  backpacking across Europe and it [Allpa 35L] had ample space
                  for everything I needed.”
                </p>
                <cite>Hunter M.</cite>
                <span>Verified Buyer</span>
              </blockquote>
            </div>
            <!-- .ctpx-non-product-item -->
          </div>
          <!-- .col-sm-6 -->
        </div>
        <!-- .row -->
      </div>
      <!-- .product-grid -->
    </div>
    <!-- .container-fluid -->
  </div>
</template>

<script src="./ctrl-allpaaba-collection-grid.js"></script>
